export default __webpack_public_path__ + "static/media/checkMarkNo.5e23ce7a.svg";